module.exports = __webpack_public_path__ + "static/media/pickle.db6fbf46.png";